<template>
  <div style="display: flex; flex-direction: column">
    <div style="display: flex; justify-content: space-between">
      <cargo-input v-model="job.shipperCode" style="width:115px;margin-right: 5px;flex-grow: 1;" :placeholder="disabled ? '' : $t('SeaExport.ShipperId')" :auto-uppercase="autoUppercase" :disabled="disabled" @change="onChange('shipperCode')" />
      <cargo-company-select
        :disabled="disabled"
        :method-params="{shipper:true,active:true}"
        :default-value="job.shipperId||''"
        style="display: inline-block;width:145px;flex-grow: 1;"
        @change="shipperChange"
      />
    </div>
    <cargo-input
      v-for="i in 7"
      :key="i"
      v-model="job['shipperLine'+i]"
      :use-read-only="true"
      :disabled="disabled"
      :auto-uppercase="autoUppercase"
      style="margin-top: 5px"
      @change="onChange('shipperLine'+i)"
      @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,autoUppercase,{autoHalfWord:true,autoUppercase:autoUppercase})"
    />

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="disabled"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="!disabled"
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'SeBasicShipper',
  components: { cargoInput, cargoCompanySelect, cargoRichTextarea },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    autoUppercase: { type: Boolean, default: false }
  },
  data() {
    return {
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      }
    }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    },
    async shipperChange(data) {
      const form = this.job
      form.shipperId = data.value
      if (form.shipperId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.shipperLine1 = manifestAddress.addressLine1
          form.shipperLine2 = manifestAddress.addressLine2
          form.shipperLine3 = manifestAddress.addressLine3
          form.shipperLine4 = manifestAddress.addressLine4
          form.shipperLine5 = manifestAddress.addressLine5
          form.shipperLine6 = manifestAddress.addressLine6
          form.shipperLine7 = manifestAddress.addressLine7
        } else {
          form.shipperLine1 = ''
          form.shipperLine2 = ''
          form.shipperLine3 = ''
          form.shipperLine4 = ''
          form.shipperLine5 = ''
          form.shipperLine6 = ''
          form.shipperLine7 = ''
        }
      }
      const items = []
      items.push({ key: 'shipperId', value: form.shipperId })
      for (let i = 1; i <= 7; i++) {
        items.push({ key: `shipperLine${i}`, value: form[`shipperLine${i}`] })
      }
      this.$emit('childrenChange', items)
    },
    // 高级文本弹框相关方法
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      // 关闭弹框时的清理工作
    },
    // 合并发货人地址行
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.job['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.job['shipperLine7'] || '')
      return result.trimEnd()
    },
    // 分割发货人地址行
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['shipperLine' + i] = ''
      }

      // 通知父组件数据变更
      const items = []
      for (let j = 1; j <= 7; j++) {
        items.push({ key: `shipperLine${j}`, value: this.job[`shipperLine${j}`] })
      }
      this.$emit('childrenChange', items)
    }
  }
}
</script>
